var _mask, _path, _path2, _path3, _mask2, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 20"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "expand_svg__a",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12a1 1 0 1 1 0-2h5a1 1 0 0 1 0 2H6z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 12a1 1 0 1 1 0-2h5a1 1 0 0 1 0 2H6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 12h5V8H6v4zm5-2H6v4h5v-4zm-1 1 1-1v4a3 3 0 0 0 3-3h-4zm1 1-1-1h4a3 3 0 0 0-3-3v4zm-4-1-1 1V8a3 3 0 0 0-3 3h4zm-4 0a3 3 0 0 0 3 3v-4l1 1H3z",
    mask: "url(#expand_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M3 15a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H3z"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "expand_svg__b",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 20a1 1 0 1 1 0-2h13a1 1 0 0 1 0 2H2z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 20a1 1 0 1 1 0-2h13a1 1 0 0 1 0 2H2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 20h13v-4H2v4zm13-2H2v4h13v-4zm-1 1 1-1v4a3 3 0 0 0 3-3h-4zm1 1-1-1h4a3 3 0 0 0-3-3v4zM3 19l-1 1v-4a3 3 0 0 0-3 3h4zm-4 0a3 3 0 0 0 3 3v-4l1 1h-4z",
    mask: "url(#expand_svg__b)"
  })));
};
export default SvgExpand;